import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { EmptyState, PagePaper } from 'dashboard/components/common';
import { fmtMoney } from 'utilities/format';

/** Top-N products by revenue in the trailing 30d window. */
export default function TopProductsCard({ rows, loading, currency }) {
  return (
    <PagePaper sx={{ p: '18px', borderRadius: '16px' }}>
      <Typography fontWeight='700' mb='10px'>Top products (30d)</Typography>
      <TableContainer
        component={Box}
        sx={{
          border: '1px solid', borderColor: 'divider',
          borderRadius: '12px', overflowX: 'auto',
        }}
      >
        <Table size='small'>
          <TableHead sx={{ bgcolor: 'action.hover' }}>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Units</TableCell>
              <TableCell>Revenue</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && (!rows || rows.length === 0) && (
              <TableRow>
                <TableCell colSpan={3}><EmptyState>No revenue yet.</EmptyState></TableCell>
              </TableRow>
            )}
            {(rows || []).map((p, idx) => (
              <TableRow key={`${p.product_id}-${idx}`}>
                <TableCell>
                  <Typography fontWeight='600'>{p.product_name}</Typography>
                  {p.variant_name && (
                    <Typography variant='caption' color='text.secondary'>{p.variant_name}</Typography>
                  )}
                </TableCell>
                <TableCell><Typography variant='body2'>{p.units}</Typography></TableCell>
                <TableCell>
                  <Typography variant='body2'>{fmtMoney(p.revenue, p.currency || currency)}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </PagePaper>
  );
}
